module.exports = __webpack_public_path__ + "static/media/menu.b036377d.svg";